"use strict";

import { authConstants } from "../_constants";

export const loginAuthRequest = (payload) => {
    return {
        type: authConstants.AUTH_LOGIN_REQUEST,
        payload,
    };
};

export const loginAuthComplete = (payload) => {
    return {
        type: authConstants.AUTH_LOGIN_COMPLETE,
        payload,
    };
};

export const logoutAuthRequest = (payload) => {
    return {
        type: authConstants.AUTH_LOGOUT_REQUEST,
        payload,
    };
};

export const logoutAuthComplete = (payload) => {
    return {
        type: authConstants.AUTH_LOGOUT_COMPLETE,
        payload,
    };
};

export const authUserProfileDetailsRequest = (payload) => {
    return {
        type: authConstants.AUTH_USER_PROFILE_DEATAILS_REQUEST,
        payload,
    };
};

export const authUserProfileDetailsComplete = (payload) => {
    return {
        type: authConstants.AUTH_USER_PROFILE_DEATAILS_COMPLETE,
        payload,
    };
};

export const refreshTokenAuthRequest = (payload) => {
    return {
        type: authConstants.AUTH_GET_REFRESH_TOKEN_REQUEST,
        payload,
    };
};

export const refreshTokenAuthComplete = (payload) => {
    return {
        type: authConstants.AUTH_GET_REFRESH_TOKEN_COMPLETE,
        payload,
    };
};

export const preRegistrationRequest = (payload) => {
    return {
        type: authConstants.PRE_REGISTRATION_REQUEST,
        payload,
    };
};

export const preRegistrationComplete = (payload) => {
    return {
        type: authConstants.PRE_REGISTRATION_COMPLETE,
        payload,
    };
};

export const preRegistrationActivateRequest = (payload) => {
    return {
        type: authConstants.PRE_REGISTRATION_ACTIVATE_REQUEST,
        payload,
    };
};

export const preRegistrationActivateComplete = (payload) => {
    return {
        type: authConstants.PRE_REGISTRATION_ACTIVATE_COMPLETE,
        payload,
    };
};

export const forgotPasswordEmailVeryficationRequest = (payload) => {
    return {
        type: authConstants.FORGOT_PASSWORD_EMAIL_VERIIFICATION_REQUEST,
        payload,
    };
};

export const forgotPasswordEmailVeryficationComplete = (payload) => {
    return {
        type: authConstants.FORGOT_PASSWORD_EMAIL_VERIIFICATION_COMPLETE,
        payload,
    };
};

export const forgotPasswordResetPasswordRequest = (payload) => {
    return {
        type: authConstants.FORGOT_PASSWORD_RESET_PASSWORD_REQUEST,
        payload,
    };
};

export const forgotPasswordResetPasswordComplete = (payload) => {
    return {
        type: authConstants.FORGOT_PASSWORD_RESET_PASSWORD_COMPLETE,
        payload,
    };
};

export const sendOtpRequest = (payload) => {
    return {
        type: authConstants.SEND_OTP_REQUEST,
        payload,
    };
};

export const sendOtpComplete = (payload) => {
    return {
        type: authConstants.SEND_OTP_COMPLETE,
        payload,
    };
};

export const reSendOtpRequest = (payload) => {
    return {
        type: authConstants.RE_SEND_OTP_REQUEST,
        payload,
    };
};

export const reSendOtpComplete = (payload) => {
    return {
        type: authConstants.RE_SEND_OTP_COMPLETE,
        payload,
    };
};

export const changePasswordRequest = (payload) => {
    return {
        type: authConstants.AUTH_CHANGE_PASSWORD_REQUEST,
        payload,
    };
};

export const changePasswordComplete = (payload) => {
    return {
        type: authConstants.AUTH_CHANGE_PASSWORD_COMPLETE,
        payload,
    };
};

export const sendOTPAfterLoginRequest = (payload) => {
    return {
        type: authConstants.AUTH_SEND_OTP_AFTER_LOGIN_REQUEST,
        payload,
    };
};

export const sendOTPAfterLoginComplete = (payload) => {
    return {
        type: authConstants.AUTH_SEND_OTP_AFTER_LOGIN_COMPLETE,
        payload,
    };
};

export const changePasswordPreAuthDetails = (payload) => {
    return {
        type: authConstants.AUTH_CHANGE_PASSWORD_PRE_AUTH_DETAILS,
        payload,
    };
};

export const changeMobileNumberRequest = (payload) => {
    return {
        type: authConstants.AUTH_CHANGE_MOBILE_NUMBER_REQUEST,
        payload,
    };
};

export const changeMobileNumberComplete = (payload) => {
    return {
        type: authConstants.AUTH_CHANGE_MOBILE_NUMBER_COMPLETE,
        payload,
    };
};

export const changePasswordPreMobileDetails = (payload) => {
    return {
        type: authConstants.AUTH_CHANGE_MOBILE_NUMBER_PRE_MOBILE_DETAILS,
        payload,
    };
};

export const profilePictureUploadRequest = (payload) => {
    return {
        type: authConstants.AUTH_CHANGE_PROFILE_PICTURE_REQUEST,
        payload,
    };
};

export const profilePictureUploadComplete = (payload) => {
    return {
        type: authConstants.AUTH_CHANGE_PROFILE_PICTURE_COMPLETE,
        payload,
    };
};

export const profileNotificationChangeRequest = (payload) => {
    return {
        type: authConstants.AUTH_CHANGE_NOTIFICATION_REQUEST,
        payload,
    };
};

export const profileNotificationChangeComplete = (payload) => {
    return {
        type: authConstants.AUTH_CHANGE_NOTIFICATION_COMPLETE,
        payload,
    };
};

export const profileChangeHomeAddressRequest = (payload) => {
    return {
        type: authConstants.AUTH_CHANGE_HOME_ADDRESS_REQUEST,
        payload,
    };
};

export const profileChangeHomeAddressComplete = (payload) => {
    return {
        type: authConstants.AUTH_CHANGE_HOME_ADDRESS_COMPLETE,
        payload,
    };
};

export const changeProfileNameRequest = (payload) => {
    return {
        type: authConstants.AUTH_CHANGE_PROFILE_NAME_REQUEST,
        payload,
    };
};

export const  changeProfileNameComplete = (payload) => {
    return {
        type: authConstants.AUTH_CHANGE_PROFILE_NAME_COMPLETE,
        payload,
    };
};

export const getUSerDetailsRequest = () => {
    return {
        type: authConstants.AUTH_GET_USER_DETAILS_REQUEST,
    };
};

export const  getUSerDetailsComplete = (payload) => {
    return {
        type: authConstants.AUTH_GET_USER_DETAILS_COMPLETE,
        payload,
    };
};

export const getParticipantProfileRequest = () => {
    return {
        type: authConstants.AUTH_GET_PARTICIPANT_PROFILE_REQUEST,
    };
};

export const  getParticipantProfileComplete = (payload) => {
    return {
        type: authConstants.AUTH_GET_PARTICIPANT_PROFILE_COMPLETE,
        payload,
    };
};

export const subscribeRequest = (payload) => {
    return {
        type: authConstants.AUTH_SUBSCRIBE_REQUEST,
        payload,
    };
};

export const  subscribeComplete = (payload) => {
    return {
        type: authConstants.AUTH_SUBSCRIBE_COMPLETE,
        payload,
    };
};

export const selectDealerShip = (payload) => {
    return {
        type: authConstants.AUTH_SELECT_DEALER_SHIP,
        payload, 
    }
}

export const  userDeviceRequest = (payload) => {
    return {
        type: authConstants.AUTH_USER_DEVICE_REQUEST,
        payload,
    };
};

export const userDeviceComplete = (payload) => {
    return {
        type: authConstants.AUTH_USER_DEVICE_COMPLETE,
        payload, 
    }
}


